import { render, staticRenderFns } from "./MailAccountConfigurations.yaml?vue&type=template&id=34d1753e&component"
import script from "./MailAccountConfigurations.yaml?vue&type=script&lang=ts&component"
export * from "./MailAccountConfigurations.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports